var _g, _path, _g2, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgValidationInvite = function SvgValidationInvite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 108,
    viewBox: "0 0 96 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11408_117223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.8216 60.4767C47.3961 60.1776 48.0797 60.1753 48.6562 60.4703L75.5213 74.2196C76.973 74.9626 76.973 77.0374 75.5213 77.7804L48.6562 91.5297C48.0797 91.8247 47.3961 91.8224 46.8216 91.5233L20.4081 77.774C18.9727 77.0269 18.9727 74.9731 20.4081 74.226L46.8216 60.4767Z",
    fill: "black",
    fillOpacity: 0.01
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11408_117223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 12,
    width: 63,
    height: 72
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.1769 13.1547C47.4145 12.4402 48.9393 12.4402 50.1769 13.1547L77.3538 28.8453C78.5914 29.5598 79.3538 30.8803 79.3538 32.3094V63.6906C79.3538 65.1197 78.5914 66.4402 77.3538 67.1547L50.1769 82.8453C48.9393 83.5598 47.4145 83.5598 46.1769 82.8453L19.0008 67.1547C17.7633 66.4402 17.0009 65.1197 17.0008 63.6907L17.0001 32.3095C17 30.8804 17.7624 29.5598 19.0001 28.8453L46.1769 13.1547Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11408_117223)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.2141 12)",
    fill: "url(#paint0_linear_11408_117223)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.98023e-8,
    y: 0.5,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -0.866025 0.5 48.6471 12.25)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2141 48)",
    fill: "url(#paint1_linear_11408_117223)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.25,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 48.2721 48.2165)",
    stroke: "white",
    strokeOpacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11408_117223)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.8335 54.4131C57.7079 54.4856 57.5874 54.6128 57.4986 54.7666C57.4098 54.9205 57.3599 55.0884 57.3599 55.2334L57.3599 57.4761C57.8114 57.3219 58.23 57.3375 58.5607 57.5285C59.0048 57.7849 59.2543 58.3363 59.2543 59.0615C59.2543 59.7867 59.0048 60.6263 58.5607 61.3955C58.23 61.9684 57.8114 62.4673 57.3599 62.8344L57.3599 65.0771C57.3599 65.2222 57.4098 65.3325 57.4986 65.3838C57.5874 65.435 57.7079 65.4231 57.8335 65.3506L70.1473 58.2412C70.2729 58.1687 70.3933 58.0415 70.4822 57.8877C70.571 57.7338 70.6209 57.5659 70.6209 57.4209L70.6209 55.1782C70.1693 55.3324 69.7508 55.3168 69.42 55.1258C68.9759 54.8694 68.7264 54.318 68.7264 53.5928C68.7264 52.8676 68.9759 52.028 69.42 51.2588C69.7508 50.6859 70.1693 50.187 70.6209 49.8199L70.6209 47.5771C70.6209 47.4321 70.571 47.3218 70.4822 47.2705C70.3933 47.2193 70.2729 47.2312 70.1473 47.3037L57.8335 54.4131Z",
    fill: "url(#paint2_linear_11408_117223)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.8287 54.3799C57.0952 53.9184 57.4566 53.5369 57.8334 53.3193L70.1472 46.21C70.524 45.9924 70.8854 45.9566 71.1519 46.1104C71.4183 46.2643 71.568 46.5952 71.568 47.0303L71.568 49.7646C71.568 50.0667 71.356 50.4339 71.0944 50.585C70.7176 50.8025 70.3562 51.184 70.0898 51.6455C69.8233 52.1071 69.6736 52.6108 69.6736 53.0459C69.6736 53.481 69.8233 53.8119 70.0898 53.9657C70.3562 54.1196 70.7176 54.0838 71.0944 53.8662C71.356 53.7152 71.568 53.8376 71.568 54.1396L71.568 56.874C71.568 57.3091 71.4183 57.8129 71.1519 58.2744C70.8854 58.7359 70.524 59.1174 70.1472 59.335L57.8334 66.4443C57.4566 66.6619 57.0952 66.6977 56.8287 66.5439C56.5623 66.39 56.4126 66.0591 56.4126 65.624L56.4126 62.8896C56.4126 62.5876 56.6246 62.2204 56.8862 62.0693C57.263 61.8518 57.6244 61.4703 57.8909 61.0088C58.1573 60.5472 58.307 60.0435 58.307 59.6084C58.307 59.1733 58.1573 58.8424 57.8909 58.6886C57.6244 58.5347 57.263 58.5705 56.8862 58.7881C56.6246 58.9391 56.4126 58.8167 56.4126 58.5146L56.4126 55.7803C56.4126 55.3452 56.5623 54.8414 56.8287 54.3799ZM57.8334 54.4131C57.7078 54.4856 57.5873 54.6128 57.4985 54.7666C57.4097 54.9204 57.3598 55.0884 57.3598 55.2334L57.3598 57.4761C57.8114 57.3219 58.2299 57.3375 58.5607 57.5285C59.0048 57.7849 59.2542 58.3363 59.2542 59.0615C59.2542 59.7867 59.0048 60.6263 58.5607 61.3955C58.2299 61.9683 57.8114 62.4673 57.3598 62.8344L57.3598 65.0771C57.3598 65.2222 57.4097 65.3325 57.4985 65.3838C57.5873 65.435 57.7078 65.4231 57.8334 65.3506L70.1472 58.2412C70.2728 58.1687 70.3933 58.0415 70.4821 57.8877C70.5709 57.7338 70.6208 57.5659 70.6208 57.4209L70.6208 55.1782C70.1693 55.3324 69.7507 55.3168 69.42 55.1258C68.9759 54.8694 68.7264 54.318 68.7264 53.5928C68.7264 52.8676 68.9759 52.028 69.42 51.2588C69.7507 50.6859 70.1693 50.187 70.6208 49.8199L70.6208 47.5771C70.6208 47.4321 70.5709 47.3218 70.4821 47.2705C70.3933 47.2193 70.2728 47.2312 70.1472 47.3037L57.8334 54.4131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0294 53.6039C65.9446 53.453 65.8222 53.3507 65.672 53.3052C65.5218 53.2596 65.3481 53.2721 65.1648 53.3417C64.9815 53.4112 64.7937 53.5359 64.6165 53.7056C64.4393 53.8753 64.2776 54.0854 64.1445 54.319L63.9904 54.5784L63.8412 54.5002C63.7084 54.4171 63.546 54.3918 63.3675 54.4263C63.1889 54.4608 62.9995 54.5542 62.8148 54.6986C62.6312 54.8392 62.4571 55.0269 62.3069 55.2459C62.1568 55.465 62.0349 55.7092 61.9514 55.9582C61.8398 56.2871 61.8008 56.6102 61.8401 56.8807C61.8793 57.1511 61.9948 57.3548 62.1697 57.4622L63.861 58.5931C63.8778 58.6043 63.898 58.6093 63.9202 58.6079C63.9424 58.6064 63.9663 58.5984 63.9904 58.5845C64.0145 58.5706 64.0384 58.551 64.0606 58.5268C64.0829 58.5026 64.103 58.4743 64.1198 58.4437L65.8088 55.3651C65.9844 55.0552 66.1005 54.7173 66.1402 54.4006C66.1799 54.0838 66.1411 53.8048 66.0294 53.6039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0294 53.6039C65.9446 53.453 65.8222 53.3507 65.672 53.3052C65.5218 53.2596 65.3481 53.2721 65.1648 53.3417C64.9815 53.4112 64.7937 53.5359 64.6165 53.7056C64.4393 53.8753 64.2776 54.0854 64.1445 54.319L63.9904 54.5784L63.8412 54.5002C63.7084 54.4171 63.546 54.3918 63.3675 54.4263C63.1889 54.4608 62.9995 54.5542 62.8148 54.6986C62.6312 54.8392 62.4571 55.0269 62.3069 55.2459C62.1568 55.465 62.0349 55.7092 61.9514 55.9582C61.8398 56.2871 61.8008 56.6102 61.8401 56.8807C61.8793 57.1511 61.9948 57.3548 62.1697 57.4622L63.861 58.5931C63.8778 58.6043 63.898 58.6093 63.9202 58.6079C63.9424 58.6064 63.9663 58.5984 63.9904 58.5845C64.0145 58.5706 64.0384 58.551 64.0606 58.5268C64.0829 58.5026 64.103 58.4743 64.1198 58.4437L65.8088 55.3651C65.9844 55.0552 66.1005 54.7173 66.1402 54.4006C66.1799 54.0838 66.1411 53.8048 66.0294 53.6039Z",
    stroke: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0378 30)",
    fill: "url(#paint3_linear_11408_117223)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.433013,
    y: 0.75,
    width: 35,
    height: 35,
    transform: "matrix(0.866025 0.5 -2.20305e-08 1 17.0959 29.7835)",
    stroke: "white",
    strokeOpacity: 0.4
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6769 14.0207C47.6051 13.4848 48.7487 13.4848 49.6769 14.0207L76.8538 29.7113C77.782 30.2472 78.3538 31.2376 78.3538 32.3094V63.6906C78.3538 64.7624 77.782 65.7528 76.8538 66.2887L49.6769 81.9793C48.7487 82.5152 47.6051 82.5152 46.6769 81.9792L19.5008 66.2887C18.5727 65.7528 18.0009 64.7624 18.0008 63.6907L18.0001 32.3094C18 31.2376 18.5718 30.2472 19.5001 29.7113L46.6769 14.0207Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11408_117223",
    x: 3.33154,
    y: 44.2507,
    width: 89.2786,
    height: 63.4985,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.388235 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11408_117223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_11408_117223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11408_117223",
    x1: -0.267884,
    y1: 0.267885,
    x2: 35.7321,
    y2: 0.267886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#999AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6263FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11408_117223",
    x1: -0.535769,
    y1: -0.267884,
    x2: 36.8338,
    y2: -0.136971,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11408_117223",
    x1: 70.6209,
    y1: 57.9647,
    x2: 59.7368,
    y2: 50.9817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11408_117223",
    x1: 17.2767,
    y1: -10.1384,
    x2: 43.4682,
    y2: -1.59252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6263FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A0CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11408_117223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5,
    height: 17.5,
    fill: "white",
    transform: "matrix(0.866025 -0.5 2.20305e-08 1 56.4126 52.125)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgValidationInvite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "validation_invite.eb99b64292a1d21186413149f5d3fb5b.svg";